"use strict";

require("../../style/default.less");
require("./index.less");
require("../../skeleton/style");
require("../../tabs/style");